export default __webpack_public_path__ + "static/media/tribel.340950ae.jpg";